import "./ServicesListSkeleton.scss";

export const ServicesListSkeleton = () => {
  return (
    <div className="services-skeleton-container">
      {/* Breadcrumb */}
      <div className="services-skeleton-breadcrumb">
        <div className="services-skeleton-breadcrumb-item pulse"></div>
        <div className="services-skeleton-breadcrumb-separator"></div>
        <div className="services-skeleton-breadcrumb-item pulse"></div>
      </div>

      {/* Page title */}
      <div className="services-skeleton-title pulse"></div>

      {/* Description */}
      <div className="services-skeleton-description pulse"></div>

      {/* Search bar */}
      <div className="services-skeleton-search">
        <div className="services-skeleton-search-input pulse"></div>
        <div className="services-skeleton-search-button pulse"></div>
      </div>

      {/* Suggested services section */}
      <div className="services-skeleton-section">
        <div className="services-skeleton-section-title pulse"></div>

        <div className="services-skeleton-suggested-grid">
          {/* Left service card */}
          <div className="services-skeleton-card-large pulse"></div>

          {/* Right service card */}
          <div className="services-skeleton-card-large pulse"></div>
        </div>
      </div>

      {/* Services for you section */}
      <div className="services-skeleton-section">
        <div className="services-skeleton-section-title pulse"></div>

        <div className="services-skeleton-services-grid">
          {/* Service card 1 */}
          <div className="services-skeleton-card">
            <div className="services-skeleton-card-content">
              <div className="services-skeleton-card-title pulse"></div>
              <div className="services-skeleton-card-description pulse"></div>
            </div>
            <div className="services-skeleton-card-icon pulse"></div>
          </div>

          {/* Service card 2 */}
          <div className="services-skeleton-card">
            <div className="services-skeleton-card-content">
              <div className="services-skeleton-card-title pulse"></div>
              <div className="services-skeleton-card-description pulse"></div>
            </div>
            <div className="services-skeleton-card-icon pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
